import { Marker } from '../queries/markersQuery';

export const allId = 'all';

export const filterMarkers = (id: string, markers?: Marker[]): Marker[] => {
  if (!markers) {
    return [];
  }

  if (id === allId) {
    return markers;
  }

  const filteredMarkers = markers.flatMap(marker => {
    const filteredBranches = marker.branches.filter(branch => branch.category.id === id);

    if (filteredBranches.length > 0) {
      const updatedMarker: Marker = {
        ...marker,
        branches: filteredBranches,
      };

      return updatedMarker;
    }

    return [];
  });

  return filteredMarkers;
};
